var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-down"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4529 4.77167H6.81878H3.54628C2.98628 4.77167 2.70628 5.44833 3.10294 5.845L6.12461 8.86667C6.60878 9.35083 7.39628 9.35083 7.88044 8.86667L9.02961 7.7175L10.9021 5.845C11.2929 5.44833 11.0129 4.77167 10.4529 4.77167Z",
    fill: "#6C7278"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.0451221d072e61e8ffd95fa79be7fb56.svg";
export { ForwardRef as ReactComponent };